import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {DEBUG_INFO_ENABLED} from './app.constants';
import {Authority} from './config/authority.constants';
import {UserRouteAccessService} from './core/auth/user-route-access-service';
import {UserRouteRoleAccessService} from './core/auth/user-route-role-access-service';
import {MainComponent} from './layouts/main/main.component';
import {AuthGuard} from "@cupoui/core/auth/AuthGuard";


@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: MainComponent,
          canActivate: [AuthGuard],
          children: [
            {
              path: '',
              pathMatch: 'full',
              redirectTo: 'home'
            },
            {
              path: 'economy',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./economy/economy.module').then(m => m.CupouiEconomyModule)
            },
            {
              path: 'home',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./home/home.module').then(m => m.CupouiHomeModule)
            },
            {
              path: 'account',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
            },
            {
              path: 'cases',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService, UserRouteRoleAccessService],
              loadChildren: () => import('./cases/cases.module').then(m => m.CupouiCasesModule)
            },
            {
              path: 'insights',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService, UserRouteRoleAccessService],
              loadChildren: () => import('./insights/insights.module').then(m => m.CupouiInsightsModule)
            },
            {
              path: 'case',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService, UserRouteRoleAccessService],
              children: [{path: ':id', loadChildren: () => import('./case/case.module').then(m => m.CupouiCaseModule)}]
            },
            {
              path: 'case-mobility/:cp/cases/:id',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService, UserRouteRoleAccessService],
              loadChildren: () => import('./case/case-mobility.module').then(m => m.CaseMobilityModule)
            },
            {
              path: 'products-contracts',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./products-contracts/products-contracts.module').then(m => m.CupouiProductsContractsModule)
            },
            {
              path: 'case-events',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./case-events/case-events.module').then(m => m.CupouiCaseEventsModule)
            },
            {
              path: 'major-incidents',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./major-incidents/major-incidents.module').then(m => m.CupouiMajorIncidentsModule)
            },
            {
              path: 'settings',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./settings/settings.module').then(m => m.CupouiSettingsModule)
            },
            {
              path: 'helpAndContact',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./contact/contact.module').then(m => m.CupouiContactModule)
            },
            {
              path: 'help',
              data: {
                authorities: [Authority.USER, Authority.ADMIN]
              },
              canActivate: [UserRouteAccessService],
              loadChildren: () => import('./help/help.module').then(m => m.CupouiHelpModule)
            }
          ]
        },
        {
          path: '**',
          redirectTo: 'home'
        }
      ],
      {
        enableTracing: DEBUG_INFO_ENABLED,
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always'
      }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
